<template>
  <div ref="chartContainer">
    <apexchart
      v-if="ready"
      ref="chart"
      type="bar"
      :height="height"
      :series="series"
      :options="chartOptions"
      :width="width"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: "StackedBarChart",
  components: { apexchart: VueApexCharts },
  props: {
    series: { type: Array, required: true },
    height: { type: [String, Number], default: 350 },
    width: { type: [String, Number], default: '100%' },
    options: { type: Object, default: () => ({}) },
    isCurrency: { type: Boolean, default: false },
  },
  data() {
    return {
      ready: false,
    };
  },
  computed: {
    chartOptions() {
      return Object.freeze(this.mergeChartOptions());
    },
  },
  methods: {
    mergeChartOptions() {
      const defaultOptions = {
        chart: {
          // Vue 3 has no `_uid` (it read undefined, so every chart got the same id); `$.uid`
          // is the per-instance counter it replaced.
          id: 'apex-stacked-bar-' + this.$.uid,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: true,
          },
          animations: { enabled: false },
          redrawOnParentResize: false,
          redrawOnWindowResize: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '90%',
            columnWidth: '90%',
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'left',
          offsetX: 40,
        },
        xaxis: {
          type: 'category',
          categories: [
            "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez",
          ],
        },
      };

      if (this.isCurrency) {
        defaultOptions.yaxis = {
          labels: {
            formatter: function (value) {
              const formatter = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
              return formatter.format(value);
            },
          },
        };

        defaultOptions.tooltip = {
          y: {
            formatter: function (val) {
              const formatter = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
              return formatter.format(val);
            },
          },
        };
      }

      return Object.assign({}, defaultOptions, this.options);
    },
    waitForContainerWidth() {
      const el = this.$refs.chartContainer;
      if (!el) return;

      if (el.offsetWidth > 0) {
        this.ready = true;
        return;
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            if (entry.contentRect.width > 0) {
              this.ready = true;
              this._resizeObserver.disconnect();
              this._resizeObserver = null;
              break;
            }
          }
        });
        this._resizeObserver.observe(el);
      } else {
        this.ready = true;
      }
    },
  },
  mounted() {
    this.waitForContainerWidth();
  },
  beforeUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  },
};
</script>
